import React, { useEffect } from 'react';

interface MetaTagsProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
}

/**
 * Component to dynamically update meta tags for social sharing
 */
const MetaTags: React.FC<MetaTagsProps> = ({
  title = "FOMO – Community‑Powered Social Platform with Creator Rewards",
  description = "Join a vibrant community, share moments that matter, and earn from your creativity with ad‑revenue share and collectible Drops.",
  image = "https://guwcqpytunuquoirejsc.supabase.co/storage/v1/object/public/fomo-assets/fomo_metatags.png",
  url = "https://fomo.you/"
}) => {
  useEffect(() => {
    // Update primary meta tags
    document.title = title;
    
    // Find and update meta tags
    const updateMetaTag = (selector: string, attribute: string, content: string) => {
      const element = document.querySelector(selector);
      if (element) {
        element.setAttribute(attribute, content);
      }
    };

    // Update standard meta tags
    updateMetaTag('meta[name="title"]', 'content', title);
    updateMetaTag('meta[name="description"]', 'content', description);
    
    // Update Open Graph meta tags
    updateMetaTag('meta[property="og:title"]', 'content', title);
    updateMetaTag('meta[property="og:description"]', 'content', description);
    updateMetaTag('meta[property="og:image"]', 'content', image);
    updateMetaTag('meta[property="og:url"]', 'content', url);
    
    // Update Twitter meta tags (Twitter uses 'name' not 'property')
    updateMetaTag('meta[name="twitter:title"]', 'content', title);
    updateMetaTag('meta[name="twitter:description"]', 'content', description);
    updateMetaTag('meta[name="twitter:image"]', 'content', image);
    updateMetaTag('meta[name="twitter:domain"]', 'content', new URL(url).hostname);
    updateMetaTag('meta[name="twitter:url"]', 'content', url);
    
    // Restore defaults when component unmounts
    return () => {
      document.title = "FOMO – Community‑Powered Social Platform with Creator Rewards";
      updateMetaTag('meta[name="title"]', 'content', "FOMO – Community‑Powered Social Platform with Creator Rewards");
      updateMetaTag('meta[name="description"]', 'content', "Join a vibrant community, share moments that matter, and earn from your creativity with ad‑revenue share and collectible Drops.");
      updateMetaTag('meta[property="og:title"]', 'content', "FOMO – Community‑Powered Social Platform with Creator Rewards");
      updateMetaTag('meta[property="og:description"]', 'content', "Join a vibrant community, share moments that matter, and earn from your creativity with ad‑revenue share and collectible Drops.");
      updateMetaTag('meta[property="og:image"]', 'content', "https://guwcqpytunuquoirejsc.supabase.co/storage/v1/object/public/fomo-assets/fomo_metatags2.png");
      updateMetaTag('meta[property="og:url"]', 'content', "https://fomo.you/");
      updateMetaTag('meta[name="twitter:title"]', 'content', "FOMO – Community‑Powered Social Platform with Creator Rewards");
      updateMetaTag('meta[name="twitter:description"]', 'content', "Join a vibrant community, share moments that matter, and earn from your creativity with ad‑revenue share and collectible Drops.");
      updateMetaTag('meta[name="twitter:image"]', 'content', "https://guwcqpytunuquoirejsc.supabase.co/storage/v1/object/public/fomo-assets/fomo_metatags2.png");
      updateMetaTag('meta[name="twitter:domain"]', 'content', "fomo.you");
      updateMetaTag('meta[name="twitter:url"]', 'content', "https://fomo.you/");
    };
  }, [title, description, image, url]);

  // This component doesn't render anything
  return null;
};

export default MetaTags;
